'use strict';

/**
 * Refreshes a form's CSRF token right before submit.
 *
 * Forms embedded in server-rendered pages carry a token that can be missing
 * (route without csrf middleware in its chain) or stale (page cache, expired
 * session). Fetching a fresh token from CSRF-Generate at submit time makes the
 * submit independent from how and when the host page was rendered.
 */

module.exports = {
  /**
   * Fetches a fresh CSRF token and writes it into the form's hidden input.
   * The returned promise always resolves: on any failure the submit proceeds
   * with whatever token is already in the page.
   *
   * @param {jQuery} $form - form with a data-csrf-url attribute pointing to CSRF-Generate
   * @returns {JQueryPromise} resolves when the token is refreshed (or refresh was skipped)
   */
  refresh: function ($form) {
    let url = $form.data('csrf-url');
    let deferred = $.Deferred();

    if (!url) {
      return deferred.resolve().promise();
    }

    $.post({ url: url, dataType: 'json' })
      .done(function (data) {
        if (data && data.csrf && data.csrf.token) {
          let $input = $form.find('input[name="' + data.csrf.tokenName + '"]');
          if (!$input.length) {
            $input = $('<input type="hidden" name="' + data.csrf.tokenName + '">').appendTo($form);
          }
          $input.val(data.csrf.token);
        }
      })
      .always(function () {
        deferred.resolve();
      });

    return deferred.promise();
  },
};
